import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export const RecallCheckInSource = {
  EmailMatch: 1,
  NameMatch: 2,
  BotAdmission: 3,
  UserIdMatch: 4,
} as const

export const RecallMeetingEndSource = {
  ApiStatus: 1,
  BotDone: 2,
  BotCallEnded: 3,
  LastParticipantLeave: 4,
} as const

export const RecallBotLeaveReason = {
  InterpreterAbsent: 'interpreter-absent',
} as const

export const RecallRejoinReason = {
  KickedInCall: 'kicked-in-call',
  KickedWaitingRoom: 'kicked-waiting-room',
  WaitingRoomTimeout: 'waiting-room-timeout',
} as const

export interface RecallSessionEventDto {
  eventType: string
  participantName?: string | null
  participantEmail?: string | null
  isBot: boolean
  eventAtUtc: string
  receivedAtUtc: string
}

export interface RecallSessionAttemptDto {
  attemptNumber: number
  recallBotId: string
  botStatus?: string | null
  botJoinedAtUtc?: string | null
  interpreterCheckInAtUtc?: string | null
  interpreterCheckOutAtUtc?: string | null
  interpreterMeetingSeconds?: number | null
  waitingRoomExcursions: number
  needsIdentityReview: boolean
  rejoinReason?: string | null
  fallbackReason?: string | null
  errorCode?: string | null
}

export interface RecallSessionDto {
  hasSession?: boolean
  botEnabledForClient?: boolean
  rejoinEnabledForClient?: boolean
  attemptCount?: number
  rejoinPending?: boolean
  bridgedSeconds?: number | null
  coverageGapSeconds?: number | null
  waitingRoomExcursions?: number
  identityDriftSuspected?: boolean
  attempts?: RecallSessionAttemptDto[]
  recallBotId: string
  botStatus?: string | null
  scheduledJoinAtUtc: string
  botJoinedAtUtc?: string | null
  meetingStartedAtUtc?: string | null
  meetingEndedAtUtc?: string | null
  interpreterCheckInAtUtc?: string | null
  interpreterCheckOutAtUtc?: string | null
  interpreterMeetingSeconds?: number | null
  checkInSource?: number | null
  meetingEndSource?: number | null
  needsIdentityReview: boolean
  fallbackTriggered: boolean
  fallbackReason?: string | null
  botLeaveReason?: string | null
  errorCode?: string | null
  events: RecallSessionEventDto[]
}

export async function fetchRecallSession(appointmentId: string | number): Promise<RecallSessionDto | null> {
  try {
    const res = await axios.get(`${API_URL}/recall/appointments/${appointmentId}/session`)
    return res?.data?.result ?? res?.data ?? null
  } catch {
    return null
  }
}
